import { render, staticRenderFns } from "./CoinReport.vue?vue&type=template&id=005af051&scoped=true"
import script from "./CoinReport.vue?vue&type=script&lang=js"
export * from "./CoinReport.vue?vue&type=script&lang=js"
import style0 from "./CoinReport.vue?vue&type=style&index=0&id=005af051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005af051",
  null
  
)

export default component.exports